import { Map, Marker, GoogleApiWrapper, Polyline } from 'google-maps-react';
import Geocode from "react-geocode";
import React from 'react';

const apiKey = "AIzaSyAadO8xCT04_rN4NILqh5fKenRLxh2jlyA";

export class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textAddresses: [
        { address: null, }
      ],
      addresses: [],
      title: [],
      skipRender: true,
    };
  }

  componentDidMount() {
    this.transformAddress(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.places.length === 2
      && nextProps.places[0].address !== null && nextProps.places[1].address !== null) {

      if (nextProps.places[0].address === this.state.textAddresses[0].address &&
        nextProps.places[1].address === this.state.textAddresses[1].address) {
        // check if addresses are the same, to prevent multiple calls
        return;
      }
      this.setState({ skipRender: true }); // Leave this skipRender to force the map to reload
      this.transformAddress(nextProps);
    } else {
      this.setState({ textAddresses: nextProps.places })
      this.setState({ skipRender: true });
    }
  }

  transformAddress = (nextProps) => {
    this.setState({ textAddresses: nextProps.places })

    let emptyAddresses = false;

	// eslint-disable-next-line
    nextProps.places.map((place) => {
      if (!place.address || place.address.length < 5)
        emptyAddresses = true;
    });

    if (emptyAddresses) {
      this.setState({ skipRender: true });
      return;
    }

    this.setState({ textAddresses: nextProps.places })
    Geocode.setApiKey(apiKey);
    let addresses = [];
    let titles = [];

	// eslint-disable-next-line
    nextProps.places.map((place, index) => {
      Geocode.fromAddress(place.address).then(
        response => {
          let location = response.results[0].geometry.location;
          addresses.push(location);
          titles[index] = place.title;

          if (addresses.length === 2) {
            var result = this.getBounds(addresses);
            this.setState({
              skipRender: false,
              bounds: result.bounds,
              center: result.center,
              titles: titles,
              addresses: addresses
            });
          }
        },
        error => {
          console.error(error);
        }
      );
    });
  }

  getBounds(addresses) {

    const ne = {
      lat: addresses[0].lat > addresses[1].lat ? addresses[0].lat : addresses[1].lat,
      lng: addresses[0].lng > addresses[1].lng ? addresses[0].lng : addresses[1].lng
    };

    const sw = {
      lat: addresses[0].lat < addresses[1].lat ? addresses[0].lat : addresses[1].lat,
      lng: addresses[0].lng < addresses[1].lng ? addresses[0].lng : addresses[1].lng
    };

    const neObj = new window.google.maps.LatLng(ne.lat, ne.lng);
    const swObj = new window.google.maps.LatLng(sw.lat, sw.lng);

    const bounds = new window.google.maps.LatLngBounds(neObj, swObj);

    const center = { lat: (ne.lat + sw.lat) / 2, lng: (ne.lng + sw.lng) / 2 };

    return { center: center, bounds: bounds };
  }

  degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
  }

  getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
    // The radius of the planet earth in meters
    let R = 6378137;
    let dLat = this.degreesToRadians(lat2 - lat1);
    let dLong = this.degreesToRadians(lng2 - lng1);
    let a = Math.sin(dLat / 2)
      *
      Math.sin(dLat / 2)
      +
      Math.cos(this.degreesToRadians(lat1))
      *
      Math.cos(this.degreesToRadians(lat1))
      *
      Math.sin(dLong / 2)
      *
      Math.sin(dLong / 2);

    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let distance = R * c * 0.001;

    distance *= 0.621371;  // Turns kilometers into miles
    distance = Math.round(distance * 100) / 100; // Round to 2 float digits

    return distance;
  }

  displayMarkers = () => {
    return this.state.skipRender || this.state.addresses.map((address, index) => {
      return <Marker
        key={index}
        id={index}
        position={{
          lat: address.lat,
          lng: address.lng
        }}
        title={this.state.titles[index]}
      />
    });
  }


  render() {
    var zoom = 1;
    var distance = 0;
    if (!this.state.skipRender && this.state.addresses.length === 2) {
      distance = this.getDistanceBetweenPoints(
        this.state.addresses[0].lat,
        this.state.addresses[0].lng,
        this.state.addresses[1].lat,
        this.state.addresses[1].lng,
      );
    }

    // The bounds are not working. Try to find a function that calculates zoom based on distance.
    if (distance < 100)
      zoom = 8;
    else if (distance < 500)
      zoom = 7;
    else if (distance < 800)
      zoom = 6;
    else if (distance < 1500)
      zoom = 5;
    else if (distance < 2600)
      zoom = 4;
    else if (distance < 3500)
      zoom = 3;
    else if (distance < 6000)
      zoom = 2

    if (this.state.bounds !== undefined) {
      return (this.state.skipRender && "Addresses not found") || (
        <React.Fragment>
          <p>Distance: {distance} miles</p>
          <Map
            zoom={zoom}
            google={this.props.google}
            initialCenter={this.state.center}
            bounds={this.state.bounds}>
            {this.displayMarkers()}
            <Polyline
              path={this.state.addresses}
              geodesic={true}
            />
          </Map>
        </React.Fragment>
      );
    }
    else
      return "";
  }
}

export default GoogleApiWrapper({
  apiKey: apiKey
})(MapContainer)


// WEBPACK FOOTER //
// ./src/areas/shared/components/mapContainer/MapContainer.js